export default function({isMonthly, isAirport, isEvent}) {
    return isAirport
        ? 'airport'
        : isEvent
        ? 'event'
        : isMonthly
        ? 'monthly'
        : 'transient';
}
